module.exports = __webpack_public_path__ + "static/media/tree-two.68877a8e.png";